import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';

//* GLOBAL STYLES

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;



    body {
      font-family: ${({ theme }) => theme.fonts.primary};
    }
   

    /*DELETE AFTER*/
    .main {
        background: white;
    }
    h1 {
        font-family: ${({ theme }) => theme.fonts.secondary.family};
        letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
        font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
        font-size: 95px;
        line-height: 100px;
    }
    h2 {
        font-family: ${({ theme }) => theme.fonts.secondary.family};
        letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
        font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
        font-size: 75px;
        line-height: 85px;
    }
    h3 {
        font-family: ${({ theme }) => theme.fonts.secondary.family};
        letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
        font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
        font-size: 45px;
        line-height: 55px;
    }
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
`;

//* TEXT-STYLES

// OPTIONS: primaryNavy
export const ButtonLarge = styled.button`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  line-height: 19px;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0.0746667px;

  transition: 0.3s;
  background: ${props => (props.navy ? '#245CAF' : '#2A5CAF')};
  color: white;
  font-size: ${props => (props.navy ? '16px' : '20px')};
  border: ${props =>
    props.navy ? '1px solid ' + '#2A5CAF' : '2px solid white'};
  min-width: 220px;
  min-height: 40px;
  cursor: pointer;
  padding: 0 10px;

  &:hover {
    background: ${props => (props.navy ? '#245CAF' : 'transparent')};
    border-color: ${props => (props.navy ? '#2A5CAF' : 'white')};
    color: ${props => (props.navy ? 'white' : '#2A5CAF')};
  }

  &:focus {
    outline: 0;
  }

  &:active {
    color: white;
    background: ${props => (props.navy ? '#245CAF' : '#2A5CAF')};

    border: ${props =>
      props.navy ? '1px solid ' + '#2A5CAF' : '2px solid white'};
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;
  width: 100%;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;

export const ButtonFabrics = styled(ButtonLarge)`
  transition: all 0.5s ease;
  opacity: ${props => (!props.disabled ? 1 : 0.5)};
  border: 1px solid ${props => (props.active ? 'white' : 'black')};
  background: ${props => (props.active ? '#2A5CAF' : 'white')};
  color: ${props => (props.active ? 'white' : props.theme.colors.charcoal)};
  font-weight: bold;
  min-width: auto;

  &:hover {
    border: 1px solid ${props => (props.active ? '#2A5CAF' : '#2A5CAF')};
    background: ${props => (props.active ? 'white' : '#2A5CAF')};
    color: ${props => (props.active ? '#2A5CAF' : 'white')};
  }

  @media (max-width: 768px) {
    &:hover {
      border: 1px solid ${props => (props.active ? 'white' : 'black')};
      background: ${props => (props.active ? '#2A5CAF' : 'white')};
      color: ${props => (props.active ? 'white' : props.theme.colors.charcoal)};
    }
    min-height: 33px;
  }
`;

export const ButtonLargeWhite = styled(ButtonLarge)`
  background: transparent;
  border: 1px solid white;
  color: white;
  letter-spacing: 0.0746667px;

  &:hover {
    background: white;
  }
`;

export const ButtonOrangeWhite = styled(ButtonLarge)`
  opacity: ${props => (!props.inCart ? 1 : 0.5)};
  border: 1px solid black;
  background: ${({ theme }) => theme.colors.oatmilk};
  color: ${({ theme }) => theme.colors.charcoal};
  font-weight: bold;

  &:hover {
    background: ${({ theme }) => theme.colors.limoncello};
    color: white;
  }
`;

export const ButtonSmall = styled(ButtonLarge)`
  display: inline;
  background: white;
  border: ${props =>
    props.danger ? '1px solid #D9534F;' : '1px solid black;'};
  color: ${props => (props.danger ? '#D9534F;' : 'black;')};
  min-width: auto;
  font-size: 16px;
  padding: 0 20px;

  &:hover {
    background: ${props => (props.danger ? '#D9534F' : '#2A5CAF')};
    color: white;
    border-color: ${props => (props.danger ? '#D9534F' : '#2A5CAF')};
  }

  &:active {
    background: white;
    border: ${props =>
      props.danger ? '1px solid #D9534F' : '1px solid black'};
    color: ${props => (props.danger ? '#D9534F' : props.theme.colors.charcoal)};
  }
`;

export const Checkbox = styled.div`
  height: 20px;
  width: 20px;
  cursor: pointer;
  background-color: ${props =>
    props.checked || props.selected ? '#2A5CAF;' : 'white'};
  border: ${props =>
    props.checked || props.selected
      ? ' 1px solid #2A5CAF;'
      : '1px solid black'};
`;